module.exports = __webpack_public_path__ + "img/tag_griffin.5be40359.svg";